import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-arrays-boss',
  slug: 'boss',
  title: 'Search and paginate products',
  type: 'boss',
  estSeconds: 1200,
  contentVersion: 1,
});
